module.exports = __webpack_public_path__ + "static/media/HelveticaNeue-Bold.bf633dae.ttf";